export default __webpack_public_path__ + "static/media/hebl_full.96b25367.png";